/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetWarsWarIdKillmails200Ok
 */
export interface GetWarsWarIdKillmails200Ok {
    /**
     * A hash of this killmail
     * @type {string}
     * @memberof GetWarsWarIdKillmails200Ok
     */
    killmailHash: string;
    /**
     * ID of this killmail
     * @type {number}
     * @memberof GetWarsWarIdKillmails200Ok
     */
    killmailId: number;
}

/**
 * Check if a given object implements the GetWarsWarIdKillmails200Ok interface.
 */
export function instanceOfGetWarsWarIdKillmails200Ok(value: object): value is GetWarsWarIdKillmails200Ok {
    if (!('killmailHash' in value) || value['killmailHash'] === undefined) return false;
    if (!('killmailId' in value) || value['killmailId'] === undefined) return false;
    return true;
}

export function GetWarsWarIdKillmails200OkFromJSON(json: any): GetWarsWarIdKillmails200Ok {
    return GetWarsWarIdKillmails200OkFromJSONTyped(json, false);
}

export function GetWarsWarIdKillmails200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWarsWarIdKillmails200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'killmailHash': json['killmail_hash'],
        'killmailId': json['killmail_id'],
    };
}

export function GetWarsWarIdKillmails200OkToJSON(json: any): GetWarsWarIdKillmails200Ok {
    return GetWarsWarIdKillmails200OkToJSONTyped(json, false);
}

export function GetWarsWarIdKillmails200OkToJSONTyped(value?: GetWarsWarIdKillmails200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'killmail_hash': value['killmailHash'],
        'killmail_id': value['killmailId'],
    };
}

